exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-indicator{-webkit-animation:rotate 1s linear infinite;-moz-animation:rotate 1s linear infinite;animation:rotate 1s linear infinite}@keyframes rotate{to{transform:rotate(1turn)}}@-webkit-keyframes rotate{to{-webkit-transform:rotate(1turn)}}@-moz-keyframes rotate{to{transform:rotate(1turn)}}@keyframes dash{0%{stroke-dasharray:60;stroke-dashoffset:30}50%{stroke-dasharray:70;stroke-dashoffset:10}to{stroke-dasharray:60;stroke-dashoffset:30}}.ds-indicator__circle{-webkit-animation:dash 1s linear infinite;-moz-animation:dash 1s linear infinite;animation:dash 1s linear infinite;stroke:var(--ds-color-new-york-55);stroke-width:4}.ds-indicator__circle--inverse{stroke:var(--ds-color-london-100)}", ""]);

// exports
exports.locals = {
	"ds-indicator": "ds-indicator",
	"rotate": "rotate",
	"ds-indicator__circle": "ds-indicator__circle",
	"dash": "dash",
	"ds-indicator__circle--inverse": "ds-indicator__circle--inverse"
};